import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {ReportReceivedLazy} from "@containers/reports/readyReports/reportReceived/ReportReceived.lazy";
import PageLayout from "@view/layout/pageLayout/PageLayout";


const ReportReceivedPage = () => {
    return (
        <PageLayout

        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportReceivedLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportReceivedPage;